import PropTypes from 'prop-types';
import ActionButton from '../ActionButton/ActionButton'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_SecondaryActionButton.scss'
import React from 'react';

const SecondaryActionButton = ({buttonText
  , children
  , onClick
  , className
  , preventDefault
  , size
  , ...remainingProps
}) => (
  <ActionButton
    buttonText={buttonText}
    {...remainingProps}
    children={children}
    onClick={onClick}
    size={size === 'medium' ? null : 'large'}
    className={className}
    preventDefault={preventDefault}
    buttonClassName={styles['secondary-button']} />
)

SecondaryActionButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.string,
  preventDefault: PropTypes.bool
}

export default (SecondaryActionButton)
